import { text, index } from "drizzle-orm/sqlite-core";
import { defineTable } from "@kubdee/sdk/schema";

// ============================================================================
// marketing_campaigns — Campaign that bundles multiple posts under a theme
//
// One row per campaign (e.g. "Songkran 2026", "Q1 Promo"). Posts reference a
// campaign through `marketing_content_posts.campaign_id`; the FK is nullable
// so ad-hoc posts can exist without a parent campaign.
//
// Provider-neutral by design — campaigns own marketing intent, NOT provider
// IDs. Per-channel fan-out lives in `marketing_post_targets`.
// ============================================================================
export const marketingCampaigns = defineTable(
  "marketing",
  "campaigns",
  {
    id: text("id").primaryKey(), // ULID
    companyId: text("company_id").notNull(),
    name: text("name").notNull(),
    description: text("description"),
    status: text("status").notNull().default("draft"), // draft | active | archived
    startsAt: text("starts_at"), // ISO datetime, nullable
    endsAt: text("ends_at"), // ISO datetime, nullable
    // Audit columns
    createdAt: text("created_at").notNull(),
    createdBy: text("created_by"),
    updatedAt: text("updated_at").notNull(),
    updatedBy: text("updated_by"),
    deletedAt: text("deleted_at"),
    deletedBy: text("deleted_by"),
  },
  (table) => [
    index("marketing_campaigns_company_id_idx").on(table.companyId),
    index("marketing_campaigns_company_status_idx").on(
      table.companyId,
      table.status,
    ),
  ],
);

export type MarketingCampaign = typeof marketingCampaigns.$inferSelect;
export type NewMarketingCampaign = typeof marketingCampaigns.$inferInsert;
